import React, { Fragment } from 'react';
import Scheme from '../../models/Scheme';

const FormPartial = (props) => {
  const { scheme } = props;
  let schemeObj = new Scheme(scheme);
  
  const validateValue = (field) => {
    schemeObj.validate(field);
  }

  const changeValue = (field, value) => {
    schemeObj[field] = value;
    validateValue(field);
    props.setScheme(schemeObj.toStateJson());
  }
 
  return <Fragment>
    <div className="mb-1 col-md-6">
      <label htmlFor="name" className="form-label mb-1">Scheme Name</label>
      <input
        value={scheme.name}
        onChange={(e) => changeValue('name', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-12"
        id="name"
        aria-describedby="scheme_name_help"
        placeholder='Enter Scheme Name'
      />
      <div id="scheme_name_help" className="form-text text-danger mt-0">
        {scheme.errors.name}
      </div>
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor="cust_scheme_validity_limit" className="form-label mb-1">Scheme Validity Limit</label>
      <input
        value={scheme.cust_scheme_validity_limit}
        onChange={(e) => changeValue('cust_scheme_validity_limit', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-12"
        id="cust_scheme_validity_limit"
        aria-describedby="cust_scheme_validity_limitHelp"
        placeholder='Enter Scheme Validity Limit'
        inputMode="numeric"
      />
      <div id="cust_scheme_validity_limitHelp" className="form-text text-danger mt-0">
        {scheme.errors.cust_scheme_validity_limit}
      </div>
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor="earnings" className="form-label mb-1">Earnings</label>
      <input
        value={scheme.earnings}
        onChange={(e) => changeValue('earnings', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-12"
        placeholder='₹ 0.00/-'
        id="earnings" aria-describedby="earningsHelp"
      />
      <div id="earningsHelp" className="form-text text-danger mt-0">
      {scheme.errors.earnings}
      </div>
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor="description" className="form-label mb-1">Description</label>
      <textarea
        value={scheme.description}
        onChange={(e) => changeValue('description', e.target.value)}
        type="textarea"
        className="form-control form-control-sm font-size-12"
        id="description"
        aria-describedby="schemeDescriptionHelp"
        placeholder='Enter Scheme Description'
      />
     <div id="schemeDescriptionHelp" className="form-text text-danger mt-0">
     {scheme.errors.description}
    </div>
    </div>
  </Fragment>
}

export default FormPartial;